import React, { useEffect, useState } from 'react'
import { Button } from 'antd'
import './home-info.less'
import { useHistory } from 'react-router'
import API from 'api'
import LoginCardCom from 'components/LoginCard'
import CommonFooter from 'components/CommonFooter'
import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { IState } from 'reducers'

const featureModules = [
  {
    title: '海量的AI教学资源',
    desc: 'AI教育资源云平台拥有丰富的AI课程，覆盖幼儿、小/初/高、本科及高职，内容包括教案、课件、示范课视频、课后测评以及其他资源。教师可以轻松使用AI教育资源云平台进行备课和授课。',
    image: `${process.env.PUBLIC_URL}/images/feature-image-first.png`,
    path: '/grades/1',
    bgColor: '#fff',
  },
  {
    title: '师资培训好帮手',
    desc: 'AI教育资源云平台提供专业的AI教学师资培训资源，通过平台可以实现完整的AI教师培训流程。平台实时更新最新的教培资源。',
    image: `${process.env.PUBLIC_URL}/images/feature-image-second.png`,
    path: '/training',
    bgColor: '#f5f5f5',
  },
  {
    title: '资源共享交流，动态建设校本资源库',
    desc: 'AI教育资源云平台允许账号内教师上传分享课件及其他教学资源并设立权限，实时协同管理专属本校的AI教学资源库。',
    image: `${process.env.PUBLIC_URL}/images/feature-image-third.png`,
    path: '/resource',
    bgColor: '#fff',
  },
]

const HomeInfo = () => {
  const orgTypes = useSelector((state: IState) => state.org.modules)
  const [loginCardVisible, setVisible] = useState(false)
  const history = useHistory()

  useEffect(() => {
    window.addEventListener('scroll', listenScroll, true)
    return () => {
      window.removeEventListener('scroll', listenScroll)
    }
  }, [])

  //监听滚动条控制动画播放
  const listenScroll = () => {
    let Lgroups = document.getElementsByClassName('feature-content-left')
    for (let i = 0; i < Lgroups.length; i++) {
      let item = Lgroups[i]
      let itemOffsetHeight = (item as HTMLDivElement).offsetTop
      if (window.innerHeight + window.pageYOffset > itemOffsetHeight + 100) {
        item.classList.add('moveToTop')
      } else {
        item.classList.remove('moveToTop')
      }
    }
    let Rgroups = document.getElementsByClassName('feature-content-right')
    for (let i = 0; i < Rgroups.length; i++) {
      let item = Rgroups[i]
      let itemOffsetHeight = (item as HTMLDivElement).offsetTop
      if (window.innerHeight + window.pageYOffset > itemOffsetHeight + 100) {
        item.classList.add('moveToLeft')
      } else {
        item.classList.remove('moveToLeft')
      }
    }
  }

  const toPath = (path: string) => {
    if (API.hasLogin()) {
      if (user.type === "student") {
        history.push('/login')
        sessionStorage.clear()
        return
      }
      if (path === '/grades') {
        history.push(path + '/' + orgTypes[0].grades[0].id)
      } else {
        history.push(path)
      }
    } else {
      setVisible(true)
    }
  }

  const user = useSelector((state: IState) => state.user)
  const [courseState, setCourseState] = useState('none')
  const [resourceState, setResourceState] = useState('none')
  const [trainState, setTrainState] = useState('none')
  const [newsState, setNewsState] = useState('none')
  const homeContainerRef = useRef<HTMLDivElement | null>(null)
  return (
    <div className="layout-content-mask" ref={homeContainerRef}>
      <div className="layout-content-bg-LB"></div>
      <div className="layout-content-bg-RT" style={{}}></div>
      <div className="center-content home-info-container">
        <div className="home-title">AI教育资源云平台</div>
        <div className="home-subTitle bold">涵盖K12及本科职高校的人工智能教育资源与管理平台</div>

        {/* 导航卡片 */}
        <div className="card-group-right">
          <div
            className="module-link-card course"
            style={{ marginRight: 40, marginBottom: 48 }}
            onClick={() => toPath('/grades')}
            onMouseEnter={() => setCourseState('in')}
            onMouseLeave={() => setCourseState('out')}
          >
            <div className="module-card-info">
              <div className="title bold">课程中心</div>
              <div className="module-desc">课程中心包含了各个年级的课时内容。</div>
              <img
                className="course1 common-animation"
                src={'/images/file1.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: courseState === 'none' ? 'paused' : 'running',
                  animationName: courseState === 'out' ? 'course1r' : 'course1f',
                }}
              />
              <img
                className="course2 common-animation"
                src={'/images/file2.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: courseState === 'none' ? 'paused' : 'running',
                  animationName: courseState === 'out' ? 'course2r' : 'course2f',
                }}
              />
              <img
                className="course3 common-animation"
                src={'/images/file3.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: courseState === 'none' ? 'paused' : 'running',
                  animationName: courseState === 'out' ? 'course3r' : 'course3f',
                }}
              />
              <img
                className="course4 common-animation"
                src={'/images/file4.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: courseState === 'none' ? 'paused' : 'running',
                  animationName: courseState === 'out' ? 'course4r' : 'course4f',
                }}
              />
              <img
                className="course5 common-animation"
                src={'/images/file5.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: courseState === 'none' ? 'paused' : 'running',
                  animationName: courseState === 'out' ? 'course5r' : 'course5f',
                }}
              />
              <img
                className="course6 common-animation"
                src={'/images/file6.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: courseState === 'none' ? 'paused' : 'running',
                  animationName: courseState === 'out' ? 'course6r' : 'course6f',
                }}
              />
            </div>
          </div>
          <div
            className="module-link-card resource"
            style={{ marginBottom: 48 }}
            onClick={() => toPath('/aitools')}
            onMouseEnter={() => setResourceState('in')}
            onMouseLeave={() => setResourceState('out')}
          >
            <div className="module-card-info">
              <div className="title bold">AI备课</div>
              <div className="module-desc">AI备课收集了常见的可用于辅助备课的AI工具。</div>
              <img
                className="resource1 common-animation"
                src={'/images/file7.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: resourceState === 'none' ? 'paused' : 'running',
                  animationName: resourceState === 'out' ? 'resource1r' : 'resource1f',
                }}
              />
              <img
                className="resource2 common-animation"
                src={'/images/file8.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: resourceState === 'none' ? 'paused' : 'running',
                  animationName: resourceState === 'out' ? 'resource2r' : 'resource2f',
                }}
              />
              <img
                className="resource3 common-animation"
                src={'/images/file9.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: resourceState === 'none' ? 'paused' : 'running',
                  animationName: resourceState === 'out' ? 'resource3r' : 'resource3f',
                }}
              />
              <img
                className="resource4 common-animation"
                src={'/images/file10.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: resourceState === 'none' ? 'paused' : 'running',
                  animationName: resourceState === 'out' ? 'resource4r' : 'resource4f',
                }}
              />
              <img
                className="resource5 common-animation"
                src={'/images/file11.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: resourceState === 'none' ? 'paused' : 'running',
                  animationName: resourceState === 'out' ? 'resource5r' : 'resource5f',
                }}
              />
            </div>
          </div>
          <div
            className="module-link-card train"
            style={{ marginRight: 40 }}
            onClick={() => toPath('/training')}
            onMouseEnter={() => setTrainState('in')}
            onMouseLeave={() => setTrainState('out')}
          >
            <div className="module-card-info">
              <div className="title bold">师资培训</div>
              <div className="module-desc">
                师资培训用于给教师培训人工智能教育的知识，包括了相关视频观看及文档下载。
              </div>
              <img
                className="train1 common-animation"
                src={'/images/file12.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: trainState === 'none' ? 'paused' : 'running',
                  animationName: trainState === 'out' ? 'train1r' : 'train1f',
                }}
              />
              <img
                className="train2 common-animation"
                src={'/images/file13.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: trainState === 'none' ? 'paused' : 'running',
                  animationName: trainState === 'out' ? 'train2r' : 'train2f',
                }}
              />
              <img
                className="train3 common-animation"
                src={'/images/file14.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: trainState === 'none' ? 'paused' : 'running',
                  animationName: trainState === 'out' ? 'train3r' : 'train3f',
                }}
              />
              <img
                className="train4 common-animation"
                src={'/images/file15.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: trainState === 'none' ? 'paused' : 'running',
                  animationName: trainState === 'out' ? 'train4r' : 'train4f',
                }}
              />
              <img
                className="train5 common-animation"
                src={'/images/file16.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: trainState === 'none' ? 'paused' : 'running',
                  animationName: trainState === 'out' ? 'train5r' : 'train5f',
                }}
              />
            </div>
          </div>
          <div
            className="module-link-card news"
            onClick={() => toPath('/news')}
            onMouseEnter={() => setNewsState('in')}
            onMouseLeave={() => setNewsState('out')}
          >
            <div className="module-card-info">
              <div className="title bold">信息中心</div>
              <div className="module-desc">
                信息中心包含了人工智能行业的信息，您可以通过浏览相关信息了解人工智能行业的发展和最新动态。
              </div>
              <img
                className="news1 common-animation"
                src={'/images/file17.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: newsState === 'none' ? 'paused' : 'running',
                  animationName: newsState === 'out' ? 'news1r' : 'news1f',
                }}
              />
              <img
                className="news2 common-animation"
                src={'/images/file18.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: newsState === 'none' ? 'paused' : 'running',
                  animationName: newsState === 'out' ? 'news2r' : 'news2f',
                }}
              />
              <img
                className="news3 common-animation"
                src={'/images/file19.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: newsState === 'none' ? 'paused' : 'running',
                  animationName: newsState === 'out' ? 'news3r' : 'news3f',
                }}
              />
              <img
                className="news4 common-animation"
                src={'/images/file20.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: newsState === 'none' ? 'paused' : 'running',
                  animationName: newsState === 'out' ? 'news4r' : 'news4f',
                }}
              />
              <img
                className="news5 common-animation"
                src={'/images/file21.svg'}
                alt="module-card-svg"
                style={{
                  animationPlayState: newsState === 'none' ? 'paused' : 'running',
                  animationName: newsState === 'out' ? 'news5r' : 'news5f',
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="feature-container">
        {featureModules.map((module, index) => (
          <div className="feature-content" style={{ backgroundColor: module.bgColor }} key={index}>
            <div className="feature-content-left">
              <div className="title bold feature-content-title">{module.title}</div>
              <div className="feature-content-desc">{module.desc}</div>
              {index !== 2 ? (
                <Button className="feature-content-btn" onClick={() => toPath(module.path)}>
                  查看详情
                </Button>
              ) : (
                <></>
              )}
            </div>
            <div className="feature-content-right">
              <img src={module.image} alt="feature" />
            </div>
          </div>
        ))}
      </div>
      <div className="footer-container">
        <CommonFooter color="black" />
      </div>
      <LoginCardCom loginCardVisible={loginCardVisible} setVisible={setVisible} />
    </div>
  )
}

export default HomeInfo
